import { CommonModule } from "@angular/common";
import { ComponentFactoryResolver, ModuleWithProviders, NgModule } from "@angular/core";
import { CoreContentModule } from "@obg/ngx.core.content";
import { RouterModule } from "@obg/ngx.router";
import { ComponentFactoryService, CoreUiModule, FeatureUnavailableModule } from "@obg/ngx.ui.core";
import { isFunction } from "lodash-es";

import { BrowserNotSupportedComponent } from "./browser-not-supported/browser-not-supported.component";
import { _CORE_UI_ERRORS_CONFIG, CORE_UI_ERRORS_CONFIG } from "./const";
import { InternalErrorComponent } from "./internal-error/internal-error.component";
import { IosNativeBlockComponent } from "./ios-native-block/ios-native-block.component";
import { ErrorLayoutComponent } from "./layout/error-layout.component";
import { CoreUiErrorsConfig } from "./model";
import { NotFoundContainer } from "./not-found/not-found.container";

const ENTRY_COMPONENTS = [ErrorLayoutComponent];

const DIRECTIVES: any[] = [
	NotFoundContainer,
	BrowserNotSupportedComponent,
	InternalErrorComponent,
	ErrorLayoutComponent,
	IosNativeBlockComponent,
];

@NgModule({
	imports: [CommonModule, CoreContentModule, CoreUiModule, RouterModule, FeatureUnavailableModule],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class ErrorsModule {
	constructor(componentFactoryService: ComponentFactoryService, resolver: ComponentFactoryResolver) {
		componentFactoryService.registerLazyLoadedResolver(resolver, ...ENTRY_COMPONENTS);
	}

	static forRoot(config?: CoreUiErrorsConfig | (() => CoreUiErrorsConfig)): ModuleWithProviders<ErrorsModule> {
		return {
			ngModule: ErrorsModule,
			providers: [
				{
					provide: CORE_UI_ERRORS_CONFIG,
					useFactory: _coreUiErrosConfigFactory,
					deps: [_CORE_UI_ERRORS_CONFIG],
				},
				{ provide: _CORE_UI_ERRORS_CONFIG, useValue: config },
			],
		};
	}
}

/**
 * @internal
 */
export function _coreUiErrosConfigFactory(config?: CoreUiErrorsConfig | (() => CoreUiErrorsConfig)) {
	return isFunction(config) ? config() : config;
}
